// Invalid QR (route /invalid-qr) and catch-all for unknown routes.
import { t } from '../i18n'
import BrandLockup from '../components/BrandLockup'
import { StatusIcon, XIcon } from '../components/icons'

const InvalidQr = () => {
  return (
    <div className="cf-page">
      <div className="cf-card">
        <BrandLockup />
        <StatusIcon tone="danger" icon={XIcon} />
        <h1 className="cf-title">{t.invalidQrTitle}</h1>
        <p className="cf-subtitle">{t.invalidQrIntro}</p>
      </div>
    </div>
  )
}

export default InvalidQr
